import { CheckMarkIcon } from '@/assets/CheckMarkIcon';
import React, { FC } from 'react';

interface StepperProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: Array<string>;
}

const Stepper: FC<StepperProps> = ({ currentStep, totalSteps, stepLabels }) => {
  return (
    <div className="mb-16">
      <div className="flex items-center justify-between">
        {[...Array(totalSteps)].map((_, index) => (
          <div
            key={index}
            className="flex flex-col items-center flex-grow justify-center relative"
          >
            <div className="flex items-center justify-center flex-grow w-full absolute ">
              {index !== 0 && index < totalSteps && (
                <div
                  className={`flex-1 h-0.5 absolute w-1/2 right-1/2 ${
                    index < currentStep + 1
                      ? 'bg-gradient-to-b from-primary-green-shade to-primary-green'
                      : 'bg-gray-200'
                  }`}
                />
              )}
              <div
                className={`rounded-full flex items-center justify-center relative z-10 text-lg
              ${
                index <= currentStep
                  ? `bg-gradient-to-b from-primary-green-shade to-primary-green text-white `
                  : 'bg-gray-200'
              } ${
                index === currentStep
                  ? `w-12 h-12 before:content-[''] before:absolute before:rounded-full before:border-4 before:border-white before:p-[18px] p-3`
                  : 'w-10 h-10'
              }`}
              >
                {index !== 0 ? index + 1 : <CheckMarkIcon />}
              </div>

              {index < totalSteps - 1 && (
                <div
                  className={`flex-1 h-0.5 absolute w-1/2 left-1/2 ${
                    index < currentStep + 1
                      ? 'bg-gradient-to-b from-primary-green-shade to-primary-green'
                      : 'bg-gray-200'
                  }`}
                />
              )}
            </div>
            <div
              className={`relative top-12 max-w-min min-w-full text-center text-lg ${index === currentStep ? 'font-bold' : ''}`}
            >
              {stepLabels[index]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
